module.exports = __webpack_public_path__ + "img/logo.fc7a3d37.png";